"use strict";
/**
 * @file Created on 28.05.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * @author Tomas Leity
 */


var NotificationDocHolder =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(NotificationDocHolder, _DomainObject_1$Domai);

  function NotificationDocHolder(documentType, document) {
    var _this;

    _classCallCheck(this, NotificationDocHolder);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NotificationDocHolder).call(this));
    _this.documentType = documentType;
    _this.document = document;
    return _this;
  }

  return NotificationDocHolder;
}(DomainObject_1.DomainObject);

exports.NotificationDocHolder = NotificationDocHolder;